import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarTipoLancamentoControleAporte, setModalDeletarTipoLancamentoControleAporte } from "../redux/slices/tipoLancamentoControleAporte/tipoLancamentoControleAporteSlice";

export const cadastrarTipoLancamentoControleAporte = createAsyncThunk("/TipoLancamentoControleAporte/CadastrarTipoLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/TipoLancamentoControleAporte/CadastrarTipoLancamentoControleAporte", payload.value);
    toastSucess("Tipo de lançamento de controle de aporte cadastrado com sucesso");
    dispatch(setModalCadastrarTipoLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarTipoLancamentoControleAporte = createAsyncThunk("/TipoLancamentoControleAporte/BuscarTipoLancamentoControleAporte", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/TipoLancamentoControleAporte/BuscarTipoLancamentoControleAporte", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTipoLancamentoControleAporte = createAsyncThunk("/TipoLancamentoControleAporte/AtualizarTipoLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TipoLancamentoControleAporte/AtualizarTipoLancamentoControleAporte", payload.value);
    toastSucess("Tipo de lançamento de controle de aporte atualizado com sucesso");
    dispatch(setModalCadastrarTipoLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarTipoLancamentoControleAporte = createAsyncThunk("/TipoLancamentoControleAporte/DeletarTipoLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/TipoLancamentoControleAporte/DeletarTipoLancamentoControleAporte", {
      params: { id: payload.value },
    });
    toastSucess("Tipo de lançamento de controle de aporte removido com sucesso");
    dispatch(setModalDeletarTipoLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
